/* "Barrel" of Http Interceptors */
import { HttpInterceptorFn } from '@angular/common/http';

import { customerExpProxyInterceptor } from './customer-exp-proxy-interceptor';
import { globalHeadersInterceptor } from './global-headers-inteceptor';
import { globalResponseInterceptor } from './global-response-interceptor';

/** Http interceptors in outside-in order */
export const httpInterceptorFns: HttpInterceptorFn[] = [
  // First, so the header/auth checks below see the final URL.
  customerExpProxyInterceptor,
  globalHeadersInterceptor,
  globalResponseInterceptor
];
